<h2 mat-dialog-title>
  RO History</h2>
<mat-dialog-content fxLayout="column">
  <span fxFlex>Work Order: {{data.workOrder.id}}</span>
  <span fxFlex>Odometer: {{data.workOrder.odometerIn}}</span>
  <span fxFlex>Date Completed: {{data.workOrder.dateOut| date}} </span>
  <span *ngIf="data.mappedServiceGroup" fxFlex>Service: {{data.mappedServiceGroup.name}} </span>
</mat-dialog-content>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end end" style="margin-right:-8px;padding-bottom:8px;">
  <button mat-button color="primary" (click)="onCancel()">OK</button>
</div>